import { PAGEPATHS } from "components/Common/Constant"
import React, { useEffect, useState } from "react"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom" //
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { TableHeader } from "components/Common/common";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import "./datatables.scss"
import "./Accessibility.css"
import ReactApexChart from 'react-apexcharts';
import DataTableWithPopup from "components/longContentTable";
import {
  Shield,
  AlertCircle,
  Eye,
  Lightbulb,
  BarChart3,
  FileText,
  Loader
} from 'lucide-react';

const Accessibility = (props) => {
    document.title = "Accessibility Overview";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [a11yScanData, setA11yScanData] = useState({
        columns: [
            {
                label: "URL",
                field: "url",
                sort: "asc",
                width: 150,
            },
            {
                label: "Organization",
                field: "organization",
                sort: "asc",
                width: 270,
            },
            {
                label: "User",
                field: "user",
                sort: "asc",
                width: 200,
            },
            {
                label: "Domain",
                field: "Domain",
                sort: "asc",
                width: 100,
            },
            {
                label: "Type Code",
                field: "typeCode",
                sort: "asc",
                width: 100,
            },
            {
                label: "Code",
                field: "code",
                sort: "asc",
                width: 150,
            },
            {
                label: "Message",
                field: "messages",
                sort: "asc",
                width: 150,
            },
            {
                label: "Context",
                field: "context",
                sort: "asc",
                width: 150,
            },
            {
                label: "Selector",
                field: "selector",
                sort: "asc",
                width: 150,
            }
        ],
        rows: []
    })

    const [lightHouseScanData, setLightHouseScanData] = useState({
        columns: [
            {
                label: "URL",
                field: "url",
                sort: "asc",
                width: 150,
            },
            {
                label: "Organization",
                field: "organization",
                sort: "asc",
                width: 270,
            },
            {
                label: "User",
                field: "user",
                sort: "asc",
                width: 200,
            },
            {
                label: "Domain",
                field: "Domain",
                sort: "asc",
                width: 100,
            },
            {
                label: "Audit",
                field: "audit",
                sort: "asc",
                width: 100,
            },
            {
                label: "Score",
                field: "score",
                sort: "asc",
                width: 150,
            },
            {
                label: "Display Value",
                field: "displayValue",
                sort: "asc",
                width: 150,
            },
            {
                label: "Description",
                field: "description",
                sort: "asc",
                width: 150,
            },
            {
                label: "Details",
                field: "details",
                sort: "asc",
                width: 150,
            }
        ],
        rows: []
    })

    const [pieA11yoptions, setPieA11yoptions] = useState({
        chart: {
            type: 'donut'
        },
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            floating: true,
            offsetY: 130,
            offsetX: 250
        },
        labels: null,
        title: {
            text: 'A11y Scan Codes Distribution',
            align: 'center'
        }
    });

    const [pieLHoptions, setPieLHoptions] = useState({
        chart: {
            type: 'donut',
            offsetX: -100
        },
        legend: {
            position: 'right',
            horizontalAlign: 'center',
            floating: true,
            offsetY: 30,
            offsetX: 150
        },
        labels: null,
        title: {
            text: 'Light House Scan Audit Distribution',
            align: 'center'
        }
    });

    const [pieA11yseries, setPieA11yseries] = useState([]);

    const [pieLHseries, setPieLHseries] = useState([]);
    const [barChartA11yData, setBarChartA11yData] = useState([]);
    const [barChartLHData, setBarChartLHData] = useState([]);


    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "Accessibility", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Accessibility", breadcrumbItems)
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_A11Y_SCAN}/${scanId}`)
                data.data.list = data.data.list.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setA11yScanData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data.list
                }))
                const barChartData = data.data.list.reduce((acc, data) => {
                    if (acc.length && acc.some(c => c.code === data.code)) {
                        acc.forEach(v => {
                            if (v.code === data.code)
                                v.count = v.count + 1
                        });
                    } else {
                        const value = {
                            code: data.code,
                            count: 1
                        }
                        acc.push(value)
                    }
                    return acc
                }, [])
                setBarChartA11yData(barChartData)
                setPieA11yseries(barChartData.map(item => item.count))
                setPieA11yoptions((prev) => ({
                    ...prev,
                    labels: barChartData.map(item => item.code),
                }))
            } catch (e) {
                console.error(e);
            }
        }
        fetchData()
    }, [scanId])

    useEffect(() => {
        const fetchLightHouseData = async () => {
            try {
                const { data } = await axiosInstance
                    .get(`${ApiNames.FETCH_LIGHTHOUSE_CATEGORY_SCAN}/accessibility/${scanId}`)
                const barChartData = data.data.reduce((acc, data) => {
                    if (acc.length && acc.some(c => c.audit === data.audit)) {
                        acc.forEach(v => {
                            if (v.audit === data.audit)
                                v.count = v.count + 1
                        });
                    } else {
                        const value = {
                            audit: data.audit,
                            count: 1
                        }
                        acc.push(value)
                    }
                    return acc
                }, [])
                setBarChartLHData(barChartData)
                setPieLHseries(barChartData.map(item => item.count))
                setPieLHoptions((prev) => ({
                    ...prev,
                    labels: barChartData.map(item => item.audit),
                }))
                data.data = data.data.map(obj => {
                    return Object.fromEntries(
                        Object.entries(obj).map(([key, value]) => [
                            key, typeof value === 'number' || typeof value === 'boolean'
                                ? value.toString()
                                : value === null
                                    ? 'NaN'
                                    : value
                        ])
                    );
                });
                setLightHouseScanData((prev) => ({
                    ...prev,
                    columns: prev.columns,
                    rows: data.data
                }))
            } catch (e) {
                console.error(e);
            }
        }
        fetchLightHouseData()
    }, [scanId])

    return (
        <React.Fragment>
            <div className="accessibility-page">
                {/* Page Header */}
                <div className="accessibility-header">
                    <div className="accessibility-header-content">
                        <div className="accessibility-icon-wrapper">
                            <Shield className="accessibility-icon" />
                        </div>
                        <div className="accessibility-header-text">
                            <h1>Accessibility Overview</h1>
                            <p>Comprehensive accessibility analysis and compliance reporting for {sessionStorage.getItem('domain')}</p>
                        </div>
                    </div>
                </div>

                {/* Summary Cards */}
                <div className="accessibility-summary">
                    <div className="summary-card">
                        <div className="summary-icon-wrapper red">
                            <AlertCircle className="summary-icon red" />
                        </div>
                        <div className="summary-content">
                            <h3>{a11yScanData.rows.length + lightHouseScanData.rows.length}</h3>
                            <p>Total Issues Found</p>
                        </div>
                    </div>

                    <div className="summary-card">
                        <div className="summary-icon-wrapper blue">
                            <Eye className="summary-icon blue" />
                        </div>
                        <div className="summary-content">
                            <h3>{a11yScanData.rows.length}</h3>
                            <p>A11y Scan Issues</p>
                        </div>
                    </div>

                    <div className="summary-card">
                        <div className="summary-icon-wrapper green">
                            <Lightbulb className="summary-icon green" />
                        </div>
                        <div className="summary-content">
                            <h3>{lightHouseScanData.rows.length}</h3>
                            <p>Lighthouse Issues</p>
                        </div>
                    </div>
                </div>

                {/* Charts Section */}
                <div className="chart-grid">
                    <div className="chart-card">
                        <h3>A11y Scan Codes Distribution</h3>
                        {pieA11yoptions.labels && pieA11yseries.length !== 0 ? (
                            <ReactApexChart
                                options={{
                                    ...pieA11yoptions,
                                    chart: {
                                        type: 'donut'
                                    },
                                    legend: {
                                        position: 'bottom',
                                        horizontalAlign: 'center',
                                        floating: false
                                    },
                                    title: {
                                        text: undefined
                                    }
                                }}
                                series={pieA11yseries}
                                type="donut"
                                height={350}
                            />
                        ) : (
                            <div className="empty-state">
                                <BarChart3 className="empty-icon" />
                                <p>No data available</p>
                            </div>
                        )}
                    </div>

                    <div className="chart-card">
                        <h3>Lighthouse Scan Audit Distribution</h3>
                        {pieLHoptions.labels && pieLHseries.length !== 0 ? (
                            <ReactApexChart
                                options={{
                                    ...pieLHoptions,
                                    chart: {
                                        type: 'donut'
                                    },
                                    legend: {
                                        position: 'bottom',
                                        horizontalAlign: 'center',
                                        floating: false
                                    },
                                    title: {
                                        text: undefined
                                    }
                                }}
                                series={pieLHseries}
                                type="donut"
                                height={350}
                            />
                        ) : (
                            <div className="empty-state">
                                <BarChart3 className="empty-icon" />
                                <p>No data available</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Issues Breakdown */}
                <div className="issues-breakdown">
                    <div className="breakdown-card">
                        <div className="breakdown-header">
                            <div className="breakdown-icon-wrapper">
                                <FileText className="breakdown-icon" />
                            </div>
                            <h3>Issues & Count</h3>
                        </div>
                        <div className="breakdown-list">
                            {barChartA11yData.length === 0 && barChartLHData.length === 0 ? (
                                <div className="empty-state">
                                    <p>No issues found</p>
                                </div>
                            ) : (
                                <>
                                    {barChartA11yData.map((value, key) => (
                                        <div key={`a11y-${key}`} className="breakdown-item">
                                            <span className="breakdown-item-label">{value.code}</span>
                                            <span className="breakdown-item-count">{value.count}</span>
                                        </div>
                                    ))}
                                    {barChartLHData.map((value, key) => (
                                        <div key={`lh-${key}`} className="breakdown-item">
                                            <span className="breakdown-item-label">{value.audit}</span>
                                            <span className="breakdown-item-count">{value.count}</span>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* A11y Scan Data Table */}
                <div className="accessibility-section">
                    <div className="section-header">
                        <Eye className="section-header-icon" />
                        <h2>A11y Scan Results</h2>
                        <span className="scan-id">Scan ID: {scanId}</span>
                    </div>
                    {a11yScanData && a11yScanData.rows && a11yScanData.rows.length > 0 ? (
                        <DataTableWithPopup noBottomColumns={false} thirdPartyData={a11yScanData} />
                    ) : (
                        <div className="empty-state">
                            <Eye className="empty-icon" />
                            <p>No A11y scan data available</p>
                        </div>
                    )}
                </div>

                {/* Lighthouse Scan Data Table */}
                <div className="accessibility-section">
                    <div className="section-header">
                        <Lightbulb className="section-header-icon" />
                        <h2>Lighthouse Scan Results</h2>
                        <span className="scan-id">Scan ID: {scanId}</span>
                    </div>
                    {lightHouseScanData && lightHouseScanData.rows && lightHouseScanData.rows.length > 0 ? (
                        <DataTableWithPopup noBottomColumns={false} thirdPartyData={lightHouseScanData} />
                    ) : (
                        <div className="empty-state">
                            <Lightbulb className="empty-icon" />
                            <p>No Lighthouse scan data available</p>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(Accessibility)